import Vue from 'vue';
import $x from './$x';
import router from '../router/router';
import store from '../store';
import vueBeforeInit from './vueBeforeInit';

$x.kyEvent = {
    init() {
        var c = window.KyAppCustom;
        if (c) {
            var app = { Vue, $x, router, store }
            if (c.changeComponent) {
                //在Vue组件被创建之前，支持定制模块修改组件
                vueBeforeInit(function (options) {
                    if (options._isComponent) {
                        var ret = c.changeComponent.call(this, this.constructor.options, app)
                        if (ret) this.constructor.options = ret
                    }
                })
            }
            try {
                c.init(app);
            } catch (e) {
                console.error(e)
            }
        }
    },
    on(event, args) {
        var c = window.KyAppCustom;
        if (c && c.on) {
            c.on(event, args)
        }
    },
}

export default $x.kyEvent
